import type { Status } from "~/components/button";

export function getStatus(state: "idle" | "loading" | "submitting"): Status {
  if (state !== "idle") return "pending";
  return "idle";
}
